import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { ICheckSession, TError } from 'entities/protected-route/types/check-auth-interface'

const CheckSessionState = (state: RootState): ICheckSession => state.checkSession

export const IsValidSession = createSelector(
    [CheckSessionState],
    (state): boolean => state.isValidSession,
)
export const LoadingCheckSession = createSelector(
    [CheckSessionState],
    (state): boolean => state.isLoading,
)
export const ErrorCheckSession  = createSelector(
    [CheckSessionState],
    (state): TError => state.error,
)
